// src/firebase.js
// Le SDK Firebase est chargé depuis le CDN plutôt qu'importé : react-scripts 3.4.1 est en
// webpack 4, qui ne résout pas les builds modulaires v9+. Les sites sans push ne paient rien.

const SDK_VERSION = '10.0.0';
const SDK_BASE_URL = 'https://www.gstatic.com/firebasejs/' + SDK_VERSION;

let sdkPromise = null;

const loadScript = (src) => new Promise((resolve, reject) => {
    if (document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Chargement impossible : ' + src));
    document.head.appendChild(script);
});

export const loadFirebaseSdk = () => {
    if (!sdkPromise) {
        sdkPromise = loadScript(SDK_BASE_URL + '/firebase-app-compat.js')
            .then(() => loadScript(SDK_BASE_URL + '/firebase-messaging-compat.js'))
            .then(() => window.firebase)
            .catch((error) => {
                sdkPromise = null;
                throw error;
            });
    }

    return sdkPromise;
};

export const buildFirebaseConfig = (webParams) => ({
    apiKey: webParams.firebase_apikey,
    authDomain: webParams.firebase_auth_domain,
    projectId: webParams.firebase_project_id,
    messagingSenderId: webParams.firebase_messaging_sender_id,
    appId: webParams.firebase_app_id,
});

export const initializeFirebaseMessaging = async (webParams) => {
    const firebase = await loadFirebaseSdk();

    if (!firebase.messaging.isSupported()) {
        console.warn('Firebase Messaging non supporté par ce navigateur');
        return null;
    }

    const app = firebase.apps.length ? firebase.app() : firebase.initializeApp(buildFirebaseConfig(webParams));

    return app.messaging();
};